export * from './ArrowTriangularRight';
